let routes = [
    {
        path: '/drivers-management',
        name: 'drivers-management',
        component: () => import('@/modules/managers/driversManagement/DriversManagement.vue')
    }
]

export default routes
